import { Button, Flex, Menu, Burger, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import EkteAiLogo from "./../../../../assets/EkteAILogo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDisclosure } from "@mantine/hooks";

import style from "./navbar.module.css";

const Navbar = () => {
    const { t } = useTranslation(["landing-page"]);
    const location = useLocation();
    const currentPath = location.pathname;

    const navigate = useNavigate();

    const [opened, { toggle }] = useDisclosure(false);

    const isActive = (path) => {
        return currentPath === path ? style.active : "";
    };

    return (
        <div className={style.wrapper}>
            <div className={style.innerWrapper}>
                <Flex w={"100%"} justify={"space-between"} align={"center"}>
                    <Link to={"/"}>
                        <Flex align={"center"} columnGap={"0.75rem"}>
                            <img className={style.logo} src={EkteAiLogo} alt=""></img>

                            <span className={style.brand}>{t("navbar.brand")}</span>
                        </Flex>
                    </Link>

                    <Flex className={style.desktopMenu} columnGap={"0rem"} align={"center"}>
                        <Link to={"/"}>
                            <span className={`${style.header} ${isActive("/")}`}>{t("navbar.home")}</span>
                        </Link>
                        <Link to={"/precision"}>
                            <span className={`${style.header} ${isActive("/precision")}`}>{t("navbar.precision")}</span>
                        </Link>
                        <Link to={"/privacy"}>
                            <span className={`${style.header} ${isActive("/privacy")}`}>{t("navbar.privacy")}</span>
                        </Link>
                        <Link to={"/pricing"}>
                            <span className={`${style.header} ${isActive("/pricing")}`}>{t("navbar.pricing")}</span>
                        </Link>
                        <Link to={"/about-us"}>
                            <span className={`${style.header} ${isActive("/about-us")}`}>{t("navbar.about_us")}</span>
                        </Link>
                        <Link to={"/contact-us"}>
                            <span className={`${style.header} ${isActive("/contact-us")}`}>{t("navbar.contact_us")}</span>
                        </Link>
                        <Button onClick={() => navigate("/sign-in")} radius={"xl"} ml={"1rem"} variant="outline" color="dark">
                            {t("navbar.login")}
                        </Button>
                    </Flex>

                    <Menu className={style.mobileMenu} opened={opened} onChange={toggle} position="bottom-end" shadow="md">
                        <Menu.Target>
                            <Burger pt={"1rem"} opened={opened} onClick={toggle} aria-label="Toggle navigation" />
                        </Menu.Target>

                        <Menu.Dropdown>
                            <Link to={"/"}>
                                <Menu.Item>
                                    <span className={`${style.header} ${isActive("/")}`}>{t("navbar.home")}</span>
                                </Menu.Item>
                            </Link>
                            <Menu.Divider my={0} />

                            <Link to={"/precision"}>
                                <Menu.Item>
                                    <span className={`${style.header} ${isActive("/precision")}`}>{t("navbar.precision")}</span>
                                </Menu.Item>
                            </Link>
                            <Menu.Divider my={0} />

                            <Link to={"/privacy"}>
                                <Menu.Item>
                                    <span className={`${style.header} ${isActive("/privacy")}`}>{t("navbar.privacy")}</span>
                                </Menu.Item>
                            </Link>
                            <Menu.Divider my={0} />

                            <Link to={"/pricing"}>
                                <Menu.Item>
                                    <span className={`${style.header} ${isActive("/pricing")}`}>{t("navbar.pricing")}</span>
                                </Menu.Item>
                            </Link>
                            <Menu.Divider my={0} />

                            <Link to={"/about-us"}>
                                <Menu.Item>
                                    <span className={`${style.header} ${isActive("/about-us")}`}>{t("navbar.about_us")}</span>
                                </Menu.Item>
                            </Link>
                            <Menu.Divider my={0} />

                            <Link to={"/contact-us"}>
                                <Menu.Item>
                                    <span className={`${style.header} ${isActive("/contact-us")}`}>{t("navbar.contact_us")}</span>
                                </Menu.Item>
                            </Link>
                            <Menu.Divider my={0} />

                            <Link to={"/sign-in"}>
                                <Menu.Item>
                                    <span className={`${style.header} ${isActive("/sign-in")}`}>{t("navbar.login")}</span>
                                </Menu.Item>
                            </Link>

                            <Link to={"/sign-up"}>
                                <Menu.Item className={style.headerWhiteBg}>
                                    <span className={`${style.headerWhite} ${isActive("/sign-up")}`}>{t("navbar.sign_up")}</span>
                                </Menu.Item>
                            </Link>
                        </Menu.Dropdown>
                    </Menu>
                </Flex>
            </div>
        </div>
    );
};

export default Navbar;
